import { defineComponent, h } from 'vue';
import { QInput } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import DesignerRegistryMixin from './DesignerRegistryMixin.jsx';

export default defineComponent({
    name: 'basic-input-dsgn',
    mixins: [DesignerRegistryMixin],
    components: { QInput },
    computed: {
        Root: function () {
            return this.root;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
        sizeStyle() {
            return utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent);
        },
        containerStyles() {
            return {
                ...utils.resolveStyleHints(this.controlData.StyleHints, this),
                ...this.sizeStyle,
            };
        },
        inputType() {
            const type = this.controlData.Type;
            if (type != null && typeof type === 'string') {
                const normalized = type.toLowerCase().trim();
                if (normalized === 'password') return 'password';
                if (['text', 'search', 'url', 'tel', 'number', 'email'].includes(normalized)) return normalized;
            }
            return 'text';
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render() {
        const isContentDef = this.parentType === 'ContentDef';
        const containerClass = isContentDef ? 'q-ma-none q-px-xs' : 'q-ma-xs';

        return (
            <div
                style={this.containerStyles}
                class={{ 'c-BasicInput': true, 'designer-container': true, selected: this.selected$, [containerClass]: true }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QInput
                    style="width: 100%"
                    type={this.inputType}
                    modelValue={this.controlData.Text || ''}
                    placeholder={this.controlData.PlaceHolder}
                    hideBottomSpace
                    dense
                    outlined
                    clearable={this.controlData.ShowClearIcon}
                    label={isContentDef || !this.controlData.Title ? undefined : this.controlData.Title}
                    readonly={false}
                />
            </div>
        );
    }
});
